import styled from 'styled-components';

export const InputArea = styled.textarea`
    width: 100%;
    height: 70px;
    resize: vertical;
`